<template>
  <div class="container">
    <Loading v-if="isFetching" />

    <RechercheCond @filtreRecherche="filtreRecherche" />
    <div class="flex-container">
      <div class="col-filtres">
        <div class="bg-filtres">
          <h4>Filtres</h4>
          <Reset @reset="reset" />
          <FiltreCond
            @filtreRegion="filtreRegion"
            @filtreFormation="filtreFormation"
            @filtreLangue="filtreLangue"
            @filtreEnLigne="filtreEnLigne"
          />
        </div>
      </div>
      <div class="col-afficher-cond" id="top-list">
        <div class="nombres-containter">
          <NombreResultatAfficher
            :formateurs="formateurs"
            :nbrResultats="nbrResultats"
            :isFetching="isFetching"
            ref="focusTargetCondTotal"
          />
          <NombrePageCourante
            :pageCourante="pageCourante"
            :nbrPages="nbrPages"
            :nbrResultats="nbrResultats"
            :nbrResultatsDernierePage="nbrResultatsDernierePage"
          />
        </div>
        <NombreResultatsParPage
          :nbrResultats="nbrResultats"
          @changerNombreResultatsParPage="changerNombreResultatsParPage"
        />
        <Formateurs
          :isFetching="isFetching"
          :formateurs="formateurs"
          :pageCourante="pageCourante"
          :nbrResultats="nbrResultats"
        />
        <div class="pagination" role="navigation">
          <PaginationPrincipal
            :formateurs="formateurs"
            :pageCourante="pageCourante"
            :nbrResultats="nbrResultats"
            :nbrPages="nbrPages"
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            @loadPage="pageChangeHandle"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import formateursData from "../public/ListeFormateurs.json"
import Loading from './components/Loading';
import FiltreCond from './components/Filtre_condamnation';
import RechercheCond from './components/Recherche_condamnation';
import Reset from './components/Reset_bouton';
import PaginationPrincipal from './components/Pagination_principal.vue';
import Formateurs from './components/Formateurs';
import NombreResultatAfficher from './components/Nombre_resultat_afficher';
import NombreResultatsParPage from './components/Nombre_resultat_par_page';
import NombrePageCourante from './components/Nombre_page_courante';

export default {
  name: 'App',
  components: {
    Loading,
    PaginationPrincipal,
    Formateurs,
    NombreResultatAfficher,
    NombreResultatsParPage,
    FiltreCond,
    RechercheCond,
    Reset,
    NombrePageCourante,
  },
  data() {
    return {
      type_condamnation: String,
      TousLesFormateurs: [],
      formateurs: [],
      nbrResultats: 10,
      nbrResultatsDernierePage: 0,
      pageCourante: 1,
      nbrPages: 0,
      bottom: false,
      isFetching: false,
      filtres: {
        Region_desservies: '',
        Type_de_formations_offertes: '',
        Langues_de_formation: '',
        IndicateurOffertEnLigne: '',
        motscles: '',
      },
    };
  },
  watch: {
    filtres: {
      handler: function () {
        this.filtreLesFormateurs();
      },
      deep: true,
    },
    condamnation(condamnation) {
      if (this.nbrResultats >= condamnation.length) {
        this.nbrResultats = condamnation.length;
      }
    },
  },
  methods: {
    async pageChangeHandle(value) {
      switch (value) {
        case 'next':
          this.pageCourante += 1;
          break;
        case 'previous':
          this.pageCourante -= 1;
          break;
        default:
          this.pageCourante = value;
      }
    },
    changerNombreResultatsParPage(nombreResultatsParPage) {
      this.nbrResultats = parseInt(nombreResultatsParPage);
      this.pageCourante = 1;
      this.filtreLesFormateurs();
    },
    filtreRegion(region) {
      this.filtres.Region_desservies = region;
      this.pageCourante = 1;
    },
    filtreFormation(formation) {
      this.filtres.Type_de_formations_offertes = formation;
      this.pageCourante = 1;
    },
    filtreLangue(langue) {
      this.filtres.Langues_de_formation = langue;
      this.pageCourante = 1;
    },
    filtreEnLigne(en_ligne) {
      if (en_ligne == true) {
        this.filtres.IndicateurOffertEnLigne = 'TRUE';
      } else {
        this.filtres.IndicateurOffertEnLigne = '';
      }
      this.pageCourante = 1;
    },
    filtreRecherche(motscles) {
      this.filtres.motscles = motscles;
      //ajout pour la pagination
      this.pageCourante = 1;
    },
    filtreLesFormateurs() {
      // On redéfinit les filtres ici parce qu'on ne peut pas accéder à this.filtres plus loin
      var filtresFormateurs = {
        Region_desservies: this.filtres.Region_desservies,
        Type_de_formations_offertes: this.filtres.Type_de_formations_offertes,
        Langues_de_formation: this.filtres.Langues_de_formation,
        IndicateurOffertEnLigne: this.filtres.IndicateurOffertEnLigne,
        motscles: this.filtres.motscles,
      };

      // On filtre chaque formateur
      this.formateurs = this.TousLesFormateurs.filter(function (formateur) {
        // Pour chaque formateur, on le compare à l'ensemble des filtres en bouclant chaque filtre
        for (var key in filtresFormateurs) {
          // Si le filtre est actif (on veut vérifier seulement les filtres qui sont définis)
          if (filtresFormateurs[key]) {
            // Si le filtre est "motscles", la vérification est différente
            if (key == 'motscles') {
              // Si le motscles n'est pas dans le nom, dans le prénom et dans l'établissement
              if (
                !formateur.Nom ||
                !formateur.Nom.toLowerCase().includes(
                  filtresFormateurs[key].toLowerCase()
                )
              ) {
                // s'il n'est pas dans le nom
                if (
                  !formateur.Prenom ||
                  !formateur.Prenom.toLowerCase().includes(
                    filtresFormateurs[key].toLowerCase()
                  )
                ) {
                  // s'il n'est pas dans le prénom
                  if (
                    !formateur.Etablissement ||
                    !formateur.Etablissement.toLowerCase().includes(
                      filtresFormateurs[key].toLowerCase()
                    )
                  ) {
                    // s'il n'est pas dans l'établissement
                    return false;
                  }
                }
              }
            } else {
              // Vérification générale des autres filtres
              // Si on trouve un filtre qui ne correspond à ce formateur, on ne l'affiche pas
              if (!formateur[key].includes(filtresFormateurs[key])) {
                return false;
              }
            }
          }
        }
        // On n'a pas trouvé de filtres qui ne correspondait pas à ce formateur, donc on l'affiche
        return true;
      });

      //ajout pour la pagination
      this.nbrPages = Math.ceil(this.formateurs.length / this.nbrResultats);

      // Calculons le nombre de résultats dans la dernière page
      this.calculerNbrResultatsDernierePage();
    },
    changeNbrResultat() {
      let nbrTotal = this.condamnation.length;
      let nbrRestants = nbrTotal - this.nbrResultats - 20;
      if (nbrTotal >= this.nbrResultats) {
        this.nbrResultats = this.nbrResultats + 20;
      }
      if (nbrRestants <= 0) {
        this.nbrResultats = nbrTotal;
      }
    },
    calculerNbrResultatsDernierePage() {
      // Calculons le nombre de résultats à la dernière page
      // Mettons qu'on a 362 résultats, 37 pages et on veut 10 résultats par page
      // Donc : 36 pages de 10 résultats et une 37e page avec 2 résultats
      // Formule : (Nombre de formateurs) - ((nombre de pages - 1) * nombre de résultats par page)
      // 362 - ((37 - 1) * 10)
      // 362 - ((36) * 10)
      // 362 - 360
      // = 2
      // Donc 2 résultats à la dernière page
      this.nbrResultatsDernierePage =
        this.formateurs.length - (this.nbrPages - 1) * this.nbrResultats;
    },
    reset() {
      // Reset data
      this.filtres.Region_desservies = '';
      this.filtres.Type_de_formations_offertes = '';
      this.filtres.Langues_de_formation = '';
      this.filtres.IndicateurOffertEnLigne = '';
      this.filtres.motscles = '';

      // Reset in DOM
      document.getElementById('recherche_par_mots_cles').value = '';
      document.getElementById('filtre_par_region').value = '';
      document.getElementById('filtre_par_formation').value = '';
      document.getElementById('filtre_par_langue').value = '';
      document.getElementById('filtre_en_ligne').checked = false;
    },
  },
  created() {
    // Fetching all the data
    fetch('./ListeFormateurs.json')
      .then((res) => res.json())
      .then((data) => {
        // On assigne la réponse à TousLesFormateurs
        this.TousLesFormateurs = data.formateurs;

        // On les affiche tous en ordre "random"
        this.formateurs = this.TousLesFormateurs.sort(
          () => Math.random() - 0.5
        );

        // Caculate the number of pages
        this.nbrPages = Math.ceil(this.formateurs.length / 10);

        // Calculons le nombre de résultats dans la dernière page
        this.calculerNbrResultatsDernierePage();
      });
  },
};
</script>

<style></style>
